<template>
    <div class="root_page_center wrapper_lookup">
        <div class="wp_lookup">
            <div class="money_lookup">
                <p>Số dư thuế hiện tại</p>
                <h3>{{ Number(amount).toLocaleString('vi-VN') }} VNĐ</h3>
                <h6>{{ formatNumberToText(amount) }}</h6>
            </div>
            <div class="quick_actions" style="display: none !important;">
                <div class="quick_action_item" v-for="(action, index) in quickActions" :key="index">
                    <div class="quick_action_icon">
                        <img :src="action.icon" :alt="action.label" />
                    </div>
                    <p>{{ action.label }}</p>
                </div>
            </div>
            <div class="withdraw_section">
                <div class="section_header">
                    <h4>Rút tiền thuế</h4>
                </div>
                <div class="withdraw_form">
                    <div class="form_row">
                        <div class="form_label">
                            <span class="form_icon bank_icon">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M3 21V7l9-4 9 4v14M3 21h18M9 21V11h6v10" stroke="#c0392b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                            </span>
                            <span>Ngân hàng</span>
                        </div>
                        <div class="form_input">
                            <input type="text" v-model="nh" placeholder="Tên ngân hàng" />
                        </div>
                    </div>
                    <div class="form_row">
                        <div class="form_label">
                            <span class="form_icon">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><rect x="2" y="5" width="20" height="14" rx="2" stroke="#c0392b" stroke-width="2"/><path d="M2 10h20" stroke="#c0392b" stroke-width="2"/></svg>
                            </span>
                            <span>Số tài khoản</span>
                        </div>
                        <div class="form_input">
                            <input type="text" v-model="stk" placeholder="Nhập số tài khoản" />
                        </div>
                    </div>
                    <div class="form_row">
                        <div class="form_label">
                            <span class="form_icon">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" stroke="#c0392b" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="7" r="4" stroke="#c0392b" stroke-width="2"/></svg>
                            </span>
                            <span>Tên người nhận</span>
                        </div>
                        <div class="form_input">
                            <input type="text" v-model="tnn" placeholder="Nhập tên người nhận" />
                        </div>
                    </div>
                    <div class="form_row">
                        <div class="form_label">
                            <span class="form_icon">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#c0392b" stroke-width="2"/><path d="M12 6v12M8 10l4-4 4 4" stroke="#c0392b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                            </span>
                            <span>Số tiền rút (VNĐ)</span>
                        </div>
                        <div class="form_input amount_input">
                            <input type="text" v-model="str" placeholder="Nhập số tiền" />
                            <button class="btn_max" @click="addMoneyMax()">Tối đa</button>
                        </div>
                    </div>
                    <button class="btn_withdraw" @click="submitConfig()">
                        <!-- <svg width="18" height="18" viewBox="0 0 24 24" fill="none" style="margin-right:8px"><path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg> -->
                        Xác nhận
                    </button>
                </div>
            </div>

            <div class="balance_info_section">
                <div class="section_header">
                    <h4>Thông tin số dư</h4>
                    <div class="update_time">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" style="margin-right:4px"><path d="M23 4v6h-6M1 20v-6h6" stroke="#c0392b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15" stroke="#c0392b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        <span>Cập nhật: {{ getCurrentDateTime() }}</span>
                    </div>
                </div>
                <div class="balance_rows">
                    <!-- <div class="balance_row">
                        <div class="balance_label">
                            <span class="balance_icon refund_icon">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" stroke="#c0392b" stroke-width="2"/><path d="M8 12l2-6h4l2 6" stroke="#c0392b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                            </span>
                            <span>Số dư</span>
                        </div>
                        <div class="balance_value text-red">{{ Number(amount).toLocaleString('vi-VN') }} VNĐ</div>
                    </div> -->
                    <div class="balance_row">
                        <div class="balance_label">
                            <span class="balance_icon paid_icon">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><rect x="3" y="3" width="18" height="18" rx="2" stroke="#e67e22" stroke-width="2"/><path d="M9 12l2 2 4-4" stroke="#e67e22" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                            </span>
                            <span>Số tiền đã kê khai</span>
                        </div>
                        <div class="balance_value text-red" style="color: #294a61;">0 VNĐ</div>
                    </div>
                    <div class="balance_row">
                        <div class="balance_label">
                            <span class="balance_icon owe_icon">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#e67e22" stroke-width="2"/><path d="M12 8v4M12 16h.01" stroke="#e67e22" stroke-width="2" stroke-linecap="round"/></svg>
                            </span>
                            <span>Số thuế còn phải nộp</span>
                        </div>
                        <div class="balance_value text-green">0 VNĐ</div>
                    </div>
                    <div class="balance_row">
                        <div class="balance_label">
                            <span class="balance_icon processing_icon">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#888" stroke-width="2"/><path d="M12 6v6l4 2" stroke="#888" stroke-width="2" stroke-linecap="round"/></svg>
                            </span>
                            <span>Số thuế đang xử lý</span>
                        </div>
                        <div class="balance_value text-red" style="color: #d48b3e;">0 VNĐ</div>
                    </div>
                </div>
            </div>

            <div class="history_section">
                <div class="section_header">
                    <h4>Lịch sử giao dịch</h4>
                    <a href="#" class="view_all">Xem tất cả <span>&rsaquo;</span></a>
                </div>
                <div class="history_list" v-if="listHistory.length > 0">
                    <div class="history_item" v-for="(item, index) in listHistory" :key="index">
                        <div class="history_icon_wrap">
                            <div class="history_icon refund">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M12 5v14M5 12l7 7 7-7" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                            </div>
                        </div>
                        <div class="history_info">
                            <p class="history_title">Khai vốn điều lệ</p>
                            <p class="history_title">{{ item.note }}</p>
                            <p class="history_date">{{ formatIsoDateTime(item.created_at) }}</p>
                        </div>
                        <div class="history_amount">{{ Number(item.amount).toLocaleString('vi-VN') }}</div>
                        <div class="history_status success">Thành công</div>
                    </div>
                </div>
                <div class="history_list_empty" v-else>
                    Chưa có giao dịch
                </div>
            </div>

            <!-- Bottom Navigation (mobile only) -->
            <div class="m_bottomnav">
                <router-link to="/" class="m_nav_item">
                    <img src="../assets/images/hm.png" alt="">
                    <p>Trang chủ</p>
                </router-link>
                <router-link to="/lookup" class="m_nav_item">
                    <img src="../assets/images/tcu.png" alt="">
                    <p>Tài khoản</p>
                </router-link>
                <router-link to="/qr-account" class="m_nav_item m_nav_center">
                    <div class="m_nav_qr"><img src="../assets/images/qr3.png" alt=""></div>
                    <p>Quét QR</p>
                </router-link>
                <router-link to="/qr" class="m_nav_item">
                    <img src="../assets/images/htr.png" alt="" class="m_nav_icon_support">
                    <p>Cá nhân</p>
                </router-link>
                <router-link to="/notification" class="m_nav_item">
                    <img src="../assets/images/k.png" alt="">
                    <p>Khác</p>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import SocketIO from 'socket.io-client'
export default {
    name: 'Lookup_tool',
    data () {
        return {
            token: window.localStorage.getItem('token'),
            nh: '',
            stk: '',
            tnn: '',
            quickActions: [
                { icon: 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><circle cx="11" cy="11" r="8" stroke="%23ffffff" stroke-width="2"/><path d="M21 21l-4.35-4.35" stroke="%23ffffff" stroke-width="2" stroke-linecap="round"/></svg>', label: 'Kiểm tra\nsố dư thuế' },
                { icon: 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" stroke="%23ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>', label: 'Rút tiền thuế' },
                { icon: 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><rect x="3" y="4" width="18" height="18" rx="2" stroke="%23ffffff" stroke-width="2"/><path d="M16 2v4M8 2v4M3 10h18" stroke="%23ffffff" stroke-width="2" stroke-linecap="round"/></svg>', label: 'Lịch sử\ngiao dịch' },
                { icon: 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" stroke="%23ffffff" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="7" r="4" stroke="%23ffffff" stroke-width="2"/></svg>', label: 'Tài khoản\nnhận tiền' },
            ],
            amount: '',
            listBank: [],
            listHistory: [],
            str: '',
            socket: null,
        }
    },
    components: {
        
    },
    computed: {
        
    },
    mounted () {
        
    },
    created () {
        this.getDataListInfo()
        this.getData()
        this.getListHistory()
        this.socketEventAmount()
    },
    beforeUnmount () {
        if (this.socket) {
            this.socket.disconnect()
        }
    },
    methods: {
        getDataListInfo () {
            this.axios.get(this.api_userInfo,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                this.tnn = response.data.data.name
                this.amount = response.data.data.balance
            }).catch(e => {
                if(e.response.status == 401){
                    localStorage.removeItem('token');
                    localStorage.removeItem('idUser');
                    this.$swal({
                        position: 'top-end',
                        icon: 'error',
                        title: 'Kết thúc phiên đăng nhập',
                        showConfirmButton: false,
                        timer: 2000
                    })
                    setTimeout(() => {
                        window.location.href = '/'
                    }, 2000);
                }
            })
        },
        async getData () {
            this.axios.get(this.api_getBusiness,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then(async (response) => {
                if(response.data.data != null){
                    this.stk = response.data.data.bank_account_number
                    const idBank = Number(response.data.data.bank_name)
                    if (idBank != null) {
                        this.nh = await this.getListBank(idBank)
                    }
                }
            })
        },
        async getListBank (id) {
            return this.axios.get(this.api_logoBanks).then((response) => {
                const nameBank = response.data.data.find(item => item.id == id);
                return nameBank ? nameBank.name : 'Tên ngân hàng';
            })
        },
        getListHistory () {
            this.axios.get(this.api_historyGd, {
                headers: {
                    Authorization: 'Bearer ' + this.token
                }
            }).then((response) => {
                this.listHistory = response.data.histories
            })
        },
        formatNumberToText(num) {
            if (num === null || num === undefined || num === '' || isNaN(num)) return 'Không đồng';
            const words = ['không', 'một', 'hai', 'ba', 'bốn', 'năm', 'sáu', 'bảy', 'tám', 'chín'];
            const units = ['', ' nghìn', ' triệu', ' tỷ', ' nghìn tỷ', ' triệu tỷ'];
            let str = String(Math.floor(Math.abs(num))).trim();
            if (str === '0') return 'Không đồng';
            // Hàm phụ đọc cụm 3 số
            function readBlock3(threeDigits, isFirstBlock) {
                let hundred = Math.floor(threeDigits / 100);
                let ten = Math.floor((threeDigits % 100) / 10);
                let one = threeDigits % 10;
                let res = '';
                if (hundred > 0 || !isFirstBlock) {
                    res += words[hundred] + ' trăm ';
                }
                if (ten === 0) {
                    if (one > 0 && (hundred > 0 || !isFirstBlock)) res += 'lẻ ';
                } else if (ten === 1) {
                    res += 'mười ';
                } else {
                    res += words[ten] + ' mươi ';
                }
                if (one === 1 && ten > 1) {
                    res += 'mốt';
                } else if (one === 5 && ten > 0) {
                    res += 'lăm';
                } else if (one > 0) {
                    res += words[one];
                }
                return res;
            }
            let i = str.length;
            let j = 0;
            let finalResult = '';
            while (i > 0) {
                let block = parseInt(str.substring(Math.max(i - 3, 0), i), 10);
                i -= 3;
                if (block > 0) {
                    let blockText = readBlock3(block, i <= 0);
                    finalResult = blockText + units[j] + ' ' + finalResult;
                }
                j++;
            }
            finalResult = finalResult.trim().replace(/\s+/g, ' ');
            return finalResult.charAt(0).toUpperCase() + finalResult.slice(1) + ' đồng';
        },
        getCurrentDateTime() {
            const now = new Date();
            // Lấy ngày, tháng, năm và thêm số 0 ở trước nếu < 10
            const date = String(now.getDate()).padStart(2, '0');
            const month = String(now.getMonth() + 1).padStart(2, '0'); // Tháng trong JS chạy từ 0-11
            const year = now.getFullYear();
            // Lấy giờ, phút và thêm số 0 ở trước nếu < 10
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            // Trả về chuỗi định dạng chuẩn
            return `${date}/${month}/${year} ${hours}:${minutes}`;
        },
        formatIsoDateTime(isoString) {
            if (!isoString) return '';
            const dateObj = new Date(isoString);
            // Kiểm tra xem chuỗi ngày tháng truyền vào có hợp lệ không
            if (isNaN(dateObj.getTime())) return 'Ngày không hợp lệ';

            // Lấy ngày, tháng, năm (Tháng trong JS bắt đầu từ 0 nên phải +1)
            const date = String(dateObj.getDate()).padStart(2, '0');
            const month = String(dateObj.getMonth() + 1).padStart(2, '0');
            const year = dateObj.getFullYear();
            
            // Lấy giờ, phút
            const hours = String(dateObj.getHours()).padStart(2, '0');
            const minutes = String(dateObj.getMinutes()).padStart(2, '0');
            
            // Trả về định dạng chuỗi theo ý bạn (có 2 khoảng trắng ở giữa)
            return `${date}/${month}/${year}  ${hours}:${minutes}`;
        },
        addMoneyMax () {
            this.str = Number(this.amount).toLocaleString('vi-VN')
        },
        submitConfig () {
            this.$swal({
                position: 'top-end',
                icon: 'error',
                title: 'Chưa hoàn tất hồ sơ !',
                showConfirmButton: false,
                timer: 2000
            })
        },
        socketEventAmount () {
            let thiss = this
            let idUser = window.localStorage.getItem('idUser')
            this.socket = SocketIO(this.linkWebAdmin, { transports: ['websocket', 'polling', 'flashsocket'], reconnection: true, reconnectionAttempts: 5, reconnectionDelay: 2000 });
            this.socket.on(`laravel_database_load-business.${idUser}:ReloadEvent`, function(result) {
                console.log(result);
                thiss.getDataListInfo()
            });
        },
    }
}
</script>